module.exports = __webpack_public_path__ + "img/plus.15e5c0be.svg";